import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IncomeReceiptDetail  {
    _originalTypeClassName = "zERP.BO.IncomeReceiptDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IncomeReceiptDetail.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.NetAmount = null;
this.VatAmount = null;
this.TaxesAmount = null;
this.DeductionsAmount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
NetAmount:any;
VatAmount:any;
TaxesAmount:any;
DeductionsAmount:any;
IncomeBudgetDetail:any;
ExpenseBudgetDetail:any;
DocumentLine:any;
TaxLine:any;
static setIncomeBudgetDetail = ($this, value) => {
var oldValue = $this.IncomeBudgetDetail;
$this.IncomeBudgetDetail = value;
if (value != null) {
}
}
static setExpenseBudgetDetail = ($this, value) => {
var oldValue = $this.ExpenseBudgetDetail;
$this.ExpenseBudgetDetail = value;
if (value != null) {
}
}
static setDocumentLine = ($this, value) => {
var oldValue = $this.DocumentLine;
$this.DocumentLine = value;
if (value != null) {
}
}
static setTaxLine = ($this, value) => {
var oldValue = $this.TaxLine;
$this.TaxLine = value;
if (value != null) {
}
}

static GetClassName(): any{return "IncomeReceiptDetail";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}